import React from 'react';
import { Button, Container, Typography, Box, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: '100%', background: 'linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%)' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ color: '#3a7bd5' }}>
            Welcome to Job Tracker
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            Manage your job applications efficiently and stay organized in your job search.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              component={Link}
              to="/login"
              variant="contained"
              size="large"
              sx={{
                background: 'linear-gradient(to right, #3a7bd5, #00d2ff)',
                color: 'white',
                '&:hover': {
                  background: 'linear-gradient(to right, #3a7bd5, #3a7bd5)',
                },
              }}
            >
              Login
            </Button>
            <Button
              component={Link}
              to="/register"
              variant="outlined"
              size="large"
              sx={{
                borderColor: '#3a7bd5',
                color: '#3a7bd5',
                '&:hover': {
                  borderColor: '#00d2ff',
                  color: '#00d2ff',
                },
              }}
            >
              Register
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default HomePage;